import React, { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material';
import Grid from "@mui/material/Grid";
import DropDown from '../../Components/Common/DropDown/DropDown';
import Button from '../../Components/Button/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { V_GetAdminGroupsByUPNNotMappedWithEntity, V_GetAdminPermission, V_GetAllEntitiesForUserAdmin, V_SaveAdminPermission } from '../../Reducers/dcoi';
import { ArrowBackIos } from '@mui/icons-material';
import EntitySelection from '../../Components/Common/EntitySelection/EntitySelection';
import Toster from '../../Components/Common/Toster/Toster';
import InputControl from '../../Components/Common/TextField/TextField';

function AddNewPermission() {
  const location = useLocation();
  const PermissionData = location.state?.PermissionData ;
  const [selectedCountry, setSelectedCountry] = useState();
  const [user, setUser] = useState(PermissionData?.EntityAdminGroupId || "");
  const [isDisabled, setIsDisabled] = useState(true);
  const[message,setMessage]=useState();
  const[alert,setAlert]=useState(false);
const[savirity,setSavirity]=useState();
  const dispatch = useDispatch();
  const { V_NotMappedWithEntityList, V_AdminPermissionList} = useSelector((state) => state.dcoi);
  useEffect(() => {
    dispatch(V_GetAdminGroupsByUPNNotMappedWithEntity());
    // dispatch(GetAllEntities());
    dispatch(V_GetAllEntitiesForUserAdmin());
    dispatch(V_GetAdminPermission());
  }, []);

  useEffect(() => {
    const isFormValid = user && selectedCountry?.Countries?.length > 0;
    setIsDisabled(!isFormValid);
  }, [user, selectedCountry]);

  const navigate = useNavigate();

  const handleChangeUser = (e) => {
    setUser(e)
  }

  const onSelectionChangeCountry = (e) => {
    setSelectedCountry(e)
  }




  const handleSubmit = () => {
    try{
      dispatch(V_SaveAdminPermission({ userGroupId: user, Countries:selectedCountry.Countries })).then((res)=>{
        if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
          setAlert(true);
          setSavirity("success");
          setMessage(res?.payload?.data[0]?.success)
          setTimeout(()=>{
          navigate(`/app-vcoi/Vcoisitecontent/VcoiManageAdminPermission`)
          },1000)
        } else if (res?.payload?.data[0]?.status === "error") {
          setAlert(true);
          setMessage(res?.payload?.data[0]?.error)
          setSavirity("error");
        } else {
          setAlert(true);
          setMessage("Something Went Wrong")
          setSavirity("error");
        }
      })
    }catch(error){
      setMessage("Something went wrong")
      setAlert(true);
      setSavirity("error");
    }

  }

  return (<>
   <Toster message={message} severity={savirity} alert={alert} setAlert={setAlert} />
    <div className='headerNavigation'><Typography sx={{ fontSize: "16px", fontWeight: "500" }}>{PermissionData ? "Edit Permission":"Add New Permission"}</Typography><Box><Typography sx={{
      color: " #212129", display: "flex", // Align icon and text horizontally
      alignItems: "center", cursor: "pointer", "&:hover": {
        textDecoration: "underLine"
      }
    }} onClick={() => {
      navigate(`/app-vcoi/vcoisitecontent/VcoiManageAdminPermission`)
    }}> <ArrowBackIos sx={{ fontSize: "inherit" }} /> Back to List</Typography> &nbsp;</Box></div>
    <Box className='boxAlignment'>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} sm={12} md={12}>
          <Typography sx={{ fontWeight: "bold" }}>VCOI User Group<span className='required'>*</span></Typography>
          {PermissionData ? <InputControl disabled={PermissionData?.EntityAdminGroupId} value={PermissionData?.EntityAdminGroup}/> :<DropDown placeholder="-- Select User Group --" value={user} options={V_NotMappedWithEntityList} onChange={handleChangeUser} />}
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Typography sx={{ fontWeight: "bold" }}>Entity<span className='required'>*</span></Typography>
          <EntitySelection data={V_AdminPermissionList?.Countries} initialSelection={{ Countries: PermissionData?.Entities }} onSelectionChange={onSelectionChangeCountry} groupID={user} />
        </Grid>
      </Grid>
    </Box>
    <Grid container spacing={2} alignItems="center" justifyContent="center">
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        sx={{ margin: "20px", display: "flex", justifyContent: "center" }}
      >
        <Button onClick={handleSubmit} label={PermissionData ? "Update" : "Save"} isDisabled={isDisabled}/>
        &nbsp;&nbsp;
        <Button label="Cancel" onClick={() => {
          navigate(`/app-vcoi/vcoisitecontent/VcoiManageAdminPermission`)
        }} />
      </Grid>
    </Grid>
  </>

  )
}

export default AddNewPermission